angular.module("siter.io").directive "submitOn", ->
  link: (scope, elm, attrs) ->
    scope.$on attrs.submitOn, ->
      setTimeout ->
        elm.trigger "submit"



// WEBPACK FOOTER //
// ./src/app/common/directives/submit-on.coffee